/**
 * RF Cart Kit
 *
 * Web component do card de kit. Usa os primitivos do Rafobase pra
 * remoção atômica e stepper (changeKitQty, removeKit).
 */

class RfCartKit extends HTMLElement {
  constructor() {
    super();
    this._busy = false;
    this._errorTimer = null;
  }

  connectedCallback() {
    this.addEventListener('click', this._handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._handleClick);
    clearTimeout(this._errorTimer);
  }

  _handleClick = (e) => {
    if (e.target.closest('[data-remove-kit]')) {
      e.preventDefault();
      this._removeKit();
    } else if (e.target.closest('[data-kit-increment]')) {
      e.preventDefault();
      this._changeQty(+1);
    } else if (e.target.closest('[data-kit-decrement]')) {
      e.preventDefault();
      this._changeQty(-1);
    }
  };

  async _removeKit() {
    if (this._busy) return;
    const slug = this.dataset.kitSlug;
    if (!slug) return;

    if (!window.RafobaseCart?.removeKit) {
      console.error('[rf-cart-kit] RafobaseCart.removeKit indisponível (app embed desatualizado)');
      this._showError('Rafobase indisponível.');
      return;
    }

    this._busy = true;
    this.setAttribute('data-removing', '');

    try {
      await window.RafobaseCart.removeKit(slug);
      // O primitivo já dispara shopify:cart:lines-update — o cart-items-component
      // do Horizon re-busca o carrinho e faz morph do drawer in-place. O card do
      // kit some no re-render. NÃO recarregar a página: isso fechava o drawer e
      // recarregava a loja (bug). Resetar o estado cobre o caso de o morph
      // preservar o elemento (hydration mode).
      this._busy = false;
      this.removeAttribute('data-removing');
    } catch (err) {
      console.error('[rf-cart-kit] Falha ao remover kit:', err);
      this._showError('Não foi possível remover o kit.');
      this.removeAttribute('data-removing');
      this._busy = false;
    }
  }

  async _changeQty(delta) {
    if (this._busy) return;
    const slug = this.dataset.kitSlug;
    if (!slug) return;

    // Fallback pra changeKitQty se não existir: usa setKitQty(current + delta)
    const primitive =
      window.RafobaseCart?.changeKitQty ||
      (window.RafobaseCart?.setKitQty
        ? (slug, d) => {
            const qtyEl = this.querySelector('[data-kit-quantity]');
            const current = parseInt(qtyEl?.textContent?.trim() || '1', 10);
            const next = Math.max(0, current + d);
            return window.RafobaseCart.setKitQty(slug, next);
          }
        : null);

    if (!primitive) {
      console.error('[rf-cart-kit] RafobaseCart.changeKitQty/setKitQty indisponível');
      this._showError('Rafobase indisponível.');
      return;
    }

    this._busy = true;
    this.setAttribute('data-busy', '');

    try {
      await primitive.call(window.RafobaseCart, slug, delta);
      // O primitivo dispara shopify:cart:lines-update → o drawer faz morph in-place
      // com a nova qty + preços recalculados. Sem reload (fechava o drawer — bug).
      this._busy = false;
      this.removeAttribute('data-busy');
    } catch (err) {
      console.error('[rf-cart-kit] Falha ao mudar qty:', err);
      this._showError('Não foi possível alterar a quantidade.');
      this.removeAttribute('data-busy');
      this._busy = false;
    }
  }

  _showError(message) {
    const errorEl = this.querySelector('[data-kit-error]');
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.classList.remove('hidden');
    clearTimeout(this._errorTimer);
    this._errorTimer = setTimeout(() => {
      errorEl.classList.add('hidden');
      errorEl.textContent = '';
    }, 4000);
  }
}

if (!customElements.get('rf-cart-kit')) {
  customElements.define('rf-cart-kit', RfCartKit);
}
